export default __webpack_public_path__ + "static/media/logo.1c9e2bdb.svg";